/// <reference path="../../typings/index.d.ts"/>

import * as React from "react";
import * as ReactDOM from "react-dom";

export interface ChatPanelProps extends React.Props<ChatPanel> {
    className?: string;
    user?: any;
}

export interface ChatPanelState {
    entries?: any;
}

const w = window;

export class ChatPanel extends React.Component<ChatPanelProps, ChatPanelState> {
    constructor(props: ChatPanelProps) {
        super(props);

        this.state = {
            entries: null
        };
    }

    private onKeyPress(event) {
        let chatInput = ReactDOM.findDOMNode(this.refs['input']);
        if (event.key === 'Enter' && chatInput['value'] !== '') {
            let database = w.firebase.database();
            ReactDOM.findDOMNode(this.refs['input']);
            database.ref('chat/' + Date.now()).set({
                displayName: this.props.user.displayName,
                content: chatInput['value']
            });
            chatInput['value'] = "";
        }
    }

    public componentDidMount() {
        let database = w.firebase.database();
        database.ref('chat').on('value', (data) => {
            this.update(data.val())
        });
    }

    private update(rawEntries) {
        let entries = []
        for (let t in rawEntries) {
            entries.push(
                <div className="chatpanel__entry">{rawEntries[t].displayName}: {rawEntries[t].content}</div>
            );
        }
        this.setState({
            entries: entries
        });
        setTimeout(()=>{
            let chatLog = ReactDOM.findDOMNode(this.refs['log']);
            chatLog['scrollTop'] = chatLog['scrollHeight'];
        },50);
    }

    public render() {
        return (
            <div className="chatpanel">
                <div ref="log" className="chatpanel__log">
                    <div className="chatpanel__spacer" />
                    {this.state.entries}
                </div>
                <input ref="input" className="chatpanel__input" type="text" onKeyPress={this.onKeyPress.bind(this)} disabled={!this.props.user}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/ChatPanel.tsx
 **/